import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';
import { getCallbacks } from '../../helper/helper';

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, _getPrototypeOf(Select).apply(this, arguments));
  }

  _createClass(Select, [{
    key: "createControlClassName",
    value: function createControlClassName() {
      return [styles.control, styles[this.props.state], this.props.className].join(' ').trim();
    }
  }, {
    key: "createSelectClassName",
    value: function createSelectClassName() {
      return [styles.select, styles[this.props.size]].join(' ').trim();
    }
  }, {
    key: "renderHelp",
    value: function renderHelp() {
      if (!this.props.help) return null;
      return React.createElement('span', {
        className: [styles.help, styles[this.props.help.color]].join(' ')
      }, this.props.help.text);
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      return React.createElement('span', {
        className: this.createSelectClassName(),
        style: this.props.style
      }, React.createElement('select', _extends({}, getCallbacks(this.props), {
        disabled: this.props.state === 'isDisabled',
        defaultValue: this.props.defaultValue,
        value: this.props.value
      }), this.props.children), this.renderHelp());
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.hasAddons) {
        return this.renderSelect();
      }

      return React.createElement('p', {
        className: this.createControlClassName(),
        style: this.props.style
      }, this.renderSelect());
    }
  }]);

  return Select;
}(Component);

export { Select as default };
Select.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  hasAddons: PropTypes.bool,
  size: PropTypes.oneOf(['isSmall', 'isMedium', 'isLarge']),
  state: PropTypes.oneOf(['isDisabled']),
  help: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.oneOf(['isPrimary', 'isInfo', 'isSuccess', 'isWarning', 'isDanger'])
  })
};
Select.defaultProps = {
  style: {},
  className: '',
  isLoading: false,
  isActive: false
};